import { Api, EVersionStage, VersionVersionFileData } from "../apiClient/Api";
import { TFunction } from "i18next";

/**
 * Resolves a translated stage label for a version.
 * @param stage - The version stage enum value
 * @param t - Translation function from useTranslation
 * @returns Translated stage label or empty string for RELEASE
 */
export const getStageLabel = (stage: EVersionStage | undefined, t: TFunction): string => {
    switch (stage) {
        case EVersionStage.INTERNAL:
            return t("versionStage.internal");
        case EVersionStage.ALPHA:
            return t("versionStage.alpha");
        case EVersionStage.BETA:
            return t("versionStage.beta");
        case EVersionStage.RELEASE_CANDIDATE:
            return t("versionStage.release_candidate");
        case EVersionStage.RELEASE:
            return t("versionStage.release");
        case EVersionStage.APPROVED:
            return t("versionStage.approved");
        default:
            return "";
    }
};

/**
 * Loads files for a version on demand. The listing endpoints no longer ship files;
 * this wrapper hits the dedicated `GET /Version/{productId}/{major}/{minor}/{patch}/files`
 * endpoint and optionally filters by host system.
 */
export const loadVersionFiles = async (
    api: Api<any>,
    productId: string,
    major: number,
    minor: number,
    patch: number,
    hostSystemIds?: string[]
): Promise<VersionVersionFileData[]> => {
    const query = hostSystemIds && hostSystemIds.length > 0 ? { hostSystemIds } : undefined;
    const response = await api.version.versionGetVersionFiles(productId, major, minor, patch, query);
    return response?.data ?? [];
};
